import { useState, useEffect, useRef} from "react";

export default function SolutionBox({value, unit, isPrefix, isNewLine, title}) {
  const prefix = isPrefix ?? false;
  const newline = isNewLine ?? false;
  const offset = Math.ceil(value/20);
  const [count, setCount] = useState(0);
  const [isStarted, setIsStarted] = useState(false);
  const ref = useRef();

  useEffect(()=>{
    const onScroll = ()=>{
      if(window.innerHeight > ref.current.getBoundingClientRect().top+100){
        if(!isStarted){
          const id = setInterval(()=>{
            setCount(prev=>{
              if(prev+offset < value) return prev+offset;
              else return value;
            })
          }, 50)
          setTimeout(()=> {clearInterval(id); setCount(value)}, 1000);
          setIsStarted(true);
        }
      };
    }

    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll); 
    };
  },[isStarted, offset, value]);


  return (
    <div ref={ref} className="flex flex-col justify-center items-center w-[246px] h-[233px] max-md:w-[170px] max-md:h-[170px] m-1 lg:m-3 bg-[#000000B0] text-white">
      <div className="text-center">
        <p className="text-xl font-light lg:text-2xl">
          {prefix? unit:""}
          <span className="text-2xl font-semibold lg:text-4xl">{count?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
          {newline? <br/>:""}
          {prefix? "":unit}</p>
      </div>
      <div className="flex items-center justify-center px-3 text-center">
        <p className="mt-4 text-xs font-light lg:mt-8 lg:text-base">{title}</p>
      </div>
    </div>
  );
}